<script lang="ts">
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import { onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import SubscriptionList from '../account/subscription/subscription-list.svelte'

    let counter = 59
    function evaluateCounter() {
        counter--
        if (counter === 0) return
        setTimeout(evaluateCounter, 1000)
    }

    async function requestConfidenceUnlock() {
        if (!confirm('Lembre-se: o desbloqueio em confiança é temporário e não poderá ser solicitado novamente.')) {
            return
        }
        const result = await window.api.users.companies.confidenceUnlock(window.store.company.companyId)
        if (!result?.success) {
            window.alert('Não foi possível realizar o desbloqueio no momento. Entre em contato com o financeiro.')
            return
        }
        location.reload()
    }

    let loading = true
    onMount(async () => {
        evaluateCounter()
        evaluateRenew()
        loading = false
        // 1x por sessão: quantas sessões esbarraram em cada tipo de bloqueio de assinatura.
        if (showRenew) window.api.users.statistics.tickOnce('paywall.renew')
        if (window.store.company.planStatus === 'blocked' || window.store.company.planStatus === 'blocked_trial') {
            window.api.users.statistics.tickOnce('paywall.blocked')
        }
    })

    let showRenew = false
    function evaluateRenew() {
        if (window.store.company.planStatus === 'renew') {
            let lastRenew = null
            if (!window.store.company.planRenewDelayedAt) {
                showRenew = true
                return
            }
            lastRenew = dayjs(new Date()).diff(window.store.company.planRenewDelayedAt, 'hour') // data de vencimento conforme último pagamento
            console.log('last-renew', lastRenew)
            if (lastRenew >= 28) {
                showRenew = true
            }
        }
    }

    async function renewCard() {
        window.open('https://pro.zandu.com.br/public/checkout?id=cab7b797-a244-4957-bbfc-bc45ed8427bb&referenceId=' + window.store.company.companyId, '_blank')
        await window.api.users.companies.delayCardRenew(window.store.company.companyId)
        location.reload()
    }

    async function delayUpdate() {
        if (!confirm('Atenção: você precisa fazer essa atualização para evitar bloqueios em seu acesso. Deseja mesmo deixar para depois?')) {
            return
        }

        const result = await window.api.users.companies.delayCardRenew(window.store.company.companyId)
        if (result.success === false) {
            alert('Não foi processar sua solicitação. Em caso de dúvidas entre em contato com o suporte.')
            return
        }
        location.reload()
    }

    async function goLogout() {
        await window.api.users.auth.logout(false)
        location.href = '/login'
    }
</script>

{#if !loading}
    {#if showRenew}
        <div class="paywall paywall-transparency">
            <div class="config-box m-4">
                <p class="subtitle text-center">
                    ATUALIZAÇÃO DO CARTÃO<br />
                    <span class="text-muted">Devido a um problema em sua assinatura será necessário informar novamente seu cartão de crédito.</span>
                </p>
                <div class="text-center">
                    {#if window.store.company.planRenewDelayed <= 7}
                        <button class="btn btn-warning" on:click={delayUpdate}>Fazer depois</button>&nbsp;&nbsp;&nbsp;
                    {/if}
                    <button class="btn btn-primary" on:click={renewCard}>Atualizar cartão</button>
                </div>
                <p class="mt-3 text-center">
                    Em caso de dúvidas acione o suporte ou o financeiro através do e-mail <code>financeiro@zandu.com.br</code>
                </p>
            </div>
        </div>
    {/if}

    {#if window.store.company.planStatus === 'blocked' || window.store.company.planStatus === 'blocked_trial'}
        <div class="paywall">
            <div class="config-box m-4">
                <div class="box_exit">
                    <button class="btn btn-outline-secondary btn-sm" on:click={goLogout}><Fa icon={faTimes}></Fa>&nbsp;Sair</button>
                </div>
                <p class="subtitle text-center">
                    ACESSO BLOQUEADO<br />
                    <span class="text-muted">Seu acesso no momento está bloqueado.</span>
                </p>
                <p>
                    O que você pode fazer:<br />
                    <span class="text-muted">
                        <ul>
                            <li>
                                Entre em contato com o <code>financeiro@zandu.com.br</code> e regularize sua assinatura;
                            </li>
                            <li>
                                Caso você já tenha realizado o pagamento desconsidere esta mensagem e entre em contato com <code>financeiro@zandu.com.br</code>.
                            </li>
                        </ul>
                    </span>
                </p>
                <p>
                    Sobre seus dados:<br />
                    <span class="text-muted">
                        <ul>
                            <li>Seus dados estão preservados e não são afetados com esta ação;</li>
                            <li>Suas automações ainda estão ativas temporariamente.</li>
                        </ul>
                    </span>
                </p>
                {#if !window.store.company.planConfidenceUnlock}
                    <div class="unlock mt-3">
                        <div class="text-muted mb-2">Você pode solicitar um desbloqueio em confiança clicando no botão abaixo.</div>
                        <div class="unlock-counter text-muted mb-2">
                            {#if counter > 0}
                                Você poderá desbloquear em <code>0:{String(counter).padStart(2, '0')}</code> segundos.
                            {:else}
                                Lembre-se: o desbloqueio é temporário e válido por 48 horas. Regularize sua assinatura o mais rápido possível.
                            {/if}
                        </div>
                        <button disabled={counter > 0} on:click={requestConfidenceUnlock} class="btn btn-primary"> Desbloquear em confiança </button>
                    </div>
                {/if}
                <div class="subs-list">
                    <SubscriptionList allowBankslip={true} onlyOverdue={true}></SubscriptionList>
                </div>
                <div class="alert alert-warning mt-3 text-center">
                    Importante: o desbloqueio não pode ser realizado pelo suporte.<br />
                    Utilize nosso financeiro no e-mail informado.
                </div>
            </div>
        </div>
    {/if}
{/if}

<style>
    .paywall {
        background-color: #111;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .paywall-transparency {
        background-color: #000000dd;
    }
    .config-box {
        max-width: 1270px;
        width: 100%;
        background-color: #222;
        box-shadow: unset !important;
    }
    .unlock {
        text-align: center;
        background-color: #33333360;
        padding: 6px;
        border-radius: 6px;
    }
    .unlock-counter {
        min-height: 25px;
        line-height: 105%;
    }

    .box_exit {
        text-align: right;
        margin-bottom: 8px;
        cursor: pointer;
        right: 16px;
    }
</style>
